import { useEffect } from 'react';

const BACKEND_URL = window.__BACKEND_URL__ || process.env.REACT_APP_BACKEND_URL;

export const FONT_CSS = {
  helvetica: 'Helvetica, Arial, sans-serif',
  times: "'Times New Roman', Times, serif",
  courier: "'Courier New', Courier, monospace",
  lato: 'Lato, sans-serif',
  montserrat: 'Montserrat, sans-serif',
  open_sans: "'Open Sans', sans-serif",
  roboto_slab: "'Roboto Slab', serif",
  merriweather: 'Merriweather, Georgia, serif',
};
const GOOGLE = {
  lato: 'Lato:wght@400;700', montserrat: 'Montserrat:wght@400;700', open_sans: 'Open+Sans:wght@400;700',
  roboto_slab: 'Roboto+Slab:wght@400;700', merriweather: 'Merriweather:wght@400;700',
};

// Loads the company's brand font (Google Fonts or uploaded TTF) and returns its CSS font-family.
export const useBrandFont = (branding, companyId) => {
  const key = branding?.font_family || 'helvetica';
  const custom = key === 'custom' && branding?.custom_font_s3_key && companyId;
  const family = custom ? `BrandFont-${companyId}` : null;
  useEffect(() => {
    if (custom) {
      const id = `brand-font-${companyId}`;
      if (document.getElementById(id)) return;
      const style = document.createElement('style');
      style.id = id;
      const base = `${BACKEND_URL}/api/public/company-font/${companyId}`;
      style.textContent = `@font-face{font-family:'${family}';src:url('${base}/regular') format('truetype');font-weight:400;}` +
        (branding.custom_font_bold_s3_key ? `@font-face{font-family:'${family}';src:url('${base}/bold') format('truetype');font-weight:700;}` : '');
      document.head.appendChild(style);
    } else if (GOOGLE[key]) {
      const id = `gfont-${key}`;
      if (document.getElementById(id)) return;
      const link = document.createElement('link');
      link.id = id; link.rel = 'stylesheet';
      link.href = `https://fonts.googleapis.com/css2?family=${GOOGLE[key]}&display=swap`;
      document.head.appendChild(link);
    }
  }, [key, custom, companyId, family, branding?.custom_font_bold_s3_key]);
  if (custom) return `'${family}', ${branding.custom_font_name ? `'${branding.custom_font_name}', ` : ''}sans-serif`;
  return FONT_CSS[key] || FONT_CSS.helvetica;
};
